var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapMarkIcon = function SvgMapMarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 18 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#181D27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.75 11.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#181D27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.75 20.75c4-4 8-7.582 8-12a8 8 0 1 0-16 0c0 4.418 4 8 8 12"
  })));
};
export { SvgMapMarkIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB2aWV3Qm94PSIwIDAgMTggMjQiCiAgd2lkdGg9IjI0IgogIGhlaWdodD0iMjQiCiAgZmlsbD0ibm9uZSIKICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0Igo+CiAgPHBhdGgKICAgIGQ9Ik04Ljc1IDExLjc1QzEwLjQwNjkgMTEuNzUgMTEuNzUgMTAuNDA2OSAxMS43NSA4Ljc1QzExLjc1IDcuMDkzMTQgMTAuNDA2OSA1Ljc1IDguNzUgNS43NUM3LjA5MzE1IDUuNzUgNS43NSA3LjA5MzE0IDUuNzUgOC43NUM1Ljc1IDEwLjQwNjkgNy4wOTMxNSAxMS43NSA4Ljc1IDExLjc1WiIKICAgIHN0cm9rZT0iIzE4MUQyNyIKICAgIHN0cm9rZS13aWR0aD0iMS41IgogICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIKICAvPgogIDxwYXRoCiAgICBkPSJNOC43NSAyMC43NUMxMi43NSAxNi43NSAxNi43NSAxMy4xNjgzIDE2Ljc1IDguNzVDMTYuNzUgNC4zMzE3MiAxMy4xNjgzIDAuNzUgOC43NSAwLjc1QzQuMzMxNzIgMC43NSAwLjc1IDQuMzMxNzIgMC43NSA4Ljc1QzAuNzUgMTMuMTY4MyA0Ljc1IDE2Ljc1IDguNzUgMjAuNzVaIgogICAgc3Ryb2tlPSIjMTgxRDI3IgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogIC8+Cjwvc3ZnPgo=";